import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { NavigationRoutes } from '../../application/router/routes';
import { Edit, LockReset } from '@mui/icons-material';
import {
    Box,
    Button,
    Container,
    Paper,
    Stack,
    Typography,
    Grid,
} from '@mui/material';
import Loader from '../../common/components/Loader';
import { useGlobalStore } from '../../application/store/store';
import { ProfileService } from './Services/ProfileService.ts';
import { useTranslation } from 'react-i18next';

export default function ProfileView() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [profile, setProfile] = useState(
        useGlobalStore((state) => state.profile)
    );
    const profileService = new ProfileService();
    const [loading, setLoading] = useState(!profile);

    useEffect(() => {
        if (!profile) {
            profileService.getProfile().then((result) => {
                setProfile(result);
                setLoading(false);
            });
        }
    }, []);

    if (loading) {
        return <Loader />;
    }

    return (
        <Container maxWidth="sm" sx={{ px: { xs: 2, sm: 3 } }}>
            <Stack spacing={3} alignItems="stretch" mt={{ xs: 3, md: 4 }}>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    sx={{
                        justifyContent: { xs: 'center', sm: 'flex-end' },
                    }}
                >
                    <Button
                        startIcon={<LockReset />}
                        variant="contained"
                        onClick={() =>
                            navigate(NavigationRoutes.updatePassword)
                        }
                        sx={{ width: { xs: '100%', sm: 'auto' } }}
                    >
                        Byt Lösenord
                    </Button>
                    <Button
                        startIcon={<Edit />}
                        variant="contained"
                        onClick={() => navigate(NavigationRoutes.updateProfile)}
                        sx={{ width: { xs: '100%', sm: 'auto' } }}
                    >
                        Redigera Användare
                    </Button>
                </Stack>

                <Paper
                    elevation={3}
                    sx={{
                        padding: { xs: 2, sm: 4 },
                        borderRadius: 2,
                        width: '100%',
                        boxSizing: 'border-box',
                    }}
                >
                    <Typography
                        variant="h4"
                        align="center"
                        gutterBottom
                        sx={{ fontSize: { xs: '1.75rem', sm: '2.125rem' } }}
                    >
                        {profile?.firstName} {profile?.lastName}
                    </Typography>
                    <Box mt={2} mb={2} borderBottom={1} borderColor="divider" />

                    <Grid container spacing={2}>
                        <Grid item xs={5} md={4}>
                            <Typography
                                variant="subtitle2"
                                color="textSecondary"
                                sx={{
                                    typography: {
                                        xs: 'body2',
                                        sm: 'subtitle2',
                                    },
                                }}
                            >
                                Användarnamn
                            </Typography>
                        </Grid>
                        <Grid item xs={7} md={8}>
                            <Typography
                                variant="body1"
                                sx={{ wordBreak: 'break-word' }}
                            >
                                {profile?.userName}
                            </Typography>
                        </Grid>

                        <Grid item xs={5} md={4}>
                            <Typography
                                variant="subtitle2"
                                color="textSecondary"
                                sx={{
                                    typography: {
                                        xs: 'body2',
                                        sm: 'subtitle2',
                                    },
                                }}
                            >
                                Epost
                            </Typography>
                        </Grid>
                        <Grid item xs={7} md={8}>
                            <Typography
                                variant="body1"
                                sx={{ wordBreak: 'break-word' }}
                            >
                                {profile?.email}
                            </Typography>
                        </Grid>

                        <Grid item xs={5} md={4}>
                            <Typography
                                variant="subtitle2"
                                color="textSecondary"
                                sx={{
                                    typography: {
                                        xs: 'body2',
                                        sm: 'subtitle2',
                                    },
                                }}
                            >
                                Roll
                            </Typography>
                        </Grid>
                        <Grid item xs={7} md={8}>
                            <Typography
                                variant="body1"
                                sx={{ wordBreak: 'break-word' }}
                            >
                                {profile?.userRoles
                                    ?.map((role) => t(role.roleName))
                                    .join(', ')}
                            </Typography>
                        </Grid>

                        <Grid item xs={5} md={4}>
                            <Typography
                                variant="subtitle2"
                                color="textSecondary"
                                sx={{
                                    typography: {
                                        xs: 'body2',
                                        sm: 'subtitle2',
                                    },
                                }}
                            >
                                KundID
                            </Typography>
                        </Grid>
                        <Grid item xs={7} md={8}>
                            <Typography
                                variant="body1"
                                sx={{ wordBreak: 'break-word' }}
                            >
                                {JSON.parse(
                                    localStorage.getItem('orgId') || 'N/A'
                                )}
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Stack>
        </Container>
    );
}
